import React, { useState}  from 'react';
import styled from 'styled-components';

import Button from '../components/Button';
import CustomInput from '../components/CustomInput';
import  CustomCheckbox from '../components/CustomCheckbox';
import { MobileWidth, navigateCookie } from '../sharedData/Constants';

import { useNavigate } from "react-router-dom";
import { setCookie } from '../functions/Cookies';


const CustomForm = () => {

    const [isValidEmail, setIsValidEmail] = useState(false);
    const [isValidName, setIsValidName] = useState(false);
    const [isValidTel, setIsValidTel] = useState(false);
    const [isValidCompany, setIsValidCompany] = useState(false);
    const [isValidCheckPolicy, setIsValidCheckPolicy] = useState(false);
    const [isValidCheckComunication, setIsValidCheckComunication] = useState(false);
    const [isValidRole, setIsValidRole] = useState(false);
    const [isValidForm, setIsValidForm] = useState(false);

    const mainInputsValid =	isValidCheckPolicy && isValidCheckComunication && isValidEmail && isValidName  && isValidTel && isValidCompany && isValidRole;

    const verifyValidForm = () => {
        setIsValidForm( mainInputsValid);
    }

    const navigate = useNavigate();
    return(
        <StyledForm id="bf-form">
            <input hidden/>
            <CustomInput verifyValidForm={verifyValidForm} setIsValidName={setIsValidName} errorMessage={'Por favor, preencha este campo.'} name={'nome'} type='text' label={'Nome'}/>
            <CustomInput verifyValidForm={verifyValidForm} setIsValidEmail={setIsValidEmail} errorMessage={'Por favor, insira um e-mail válido.'} name={'email'} type='email' label={'E-mail'}/>
            <CustomInput verifyValidForm={verifyValidForm} setIsValidCompany={setIsValidCompany} errorMessage={'Por favor, preencha este campo.'} name={'empresa'} type='text' label={'Empresa'}/>
            <CustomInput verifyValidForm={verifyValidForm} setIsValidRole={setIsValidRole} name={'cargo'} type='text' errorMessage={'Por favor, preencha este campo.'} label={'Cargo'}/>
            <CustomInput verifyValidForm={verifyValidForm} setIsValidTel={setIsValidTel} errorMessage={'Por favor, insira um telefone válido.'} name={'telefone'} type='tel' label={'Telefone'}/>
            <CustomCheckbox link={true} text={'Aceito'} verifyValidForm={verifyValidForm} setIsValidCheck={setIsValidCheckPolicy}/>
            <CustomCheckbox text={'Concordo em receber as comunicações'} verifyValidForm={verifyValidForm} setIsValidCheck={setIsValidCheckComunication}/>
            <Button onClick={() => {
                    navigate("/estudobf2024")
                    setCookie(navigateCookie, 1, 999);
                }} disabled={!isValidForm}/>
		</StyledForm>
    );
}

const StyledForm = styled.form`
    display: flex;
    flex-direction: column;
    gap: 14px;
    width: 436px;
    height: fit-content;
    flex-flow: wrap;
    justify-content: space-between;
    @media screen and (max-width: ${MobileWidth}){
        width: 100%;
        max-width: 436px;
        margin-bottom: 32px;
    }
`;

export default CustomForm;